import { render, staticRenderFns } from "./BirthYearDisplayText.vue?vue&type=template&id=2c712d9c&scoped=true&"
import script from "./BirthYearDisplayText.vue?vue&type=script&lang=js&"
export * from "./BirthYearDisplayText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c712d9c",
  null
  
)

export default component.exports